export default __webpack_public_path__ + "static/media/contact.cfd7aeb5.svg";